import { virtel_schema_smart_get } from "./ter-virtel-definition-lib";
import { _get_fixed_fields } from "./ter-virtel-utils";
import { _getParamsFromLib } from "./ter-params-utils";
import { js_utils } from "../utils/frfr-js-utils";
import { SPACE } from "../utils/frfr-string-consts";
import { derAutoCreateVirbom_terkk_demper_children, derAutoCreateVirbom_terkk_demper_prepare_vir_input, _derivat_demper_izracunaj_brojkrilaca, _derivat_demper_izracunaj_naziv } from "./ter-derivat-lib-terkk-demper";
import { virbomCounter } from "../utils/frfr-virbom-counter-utils";
import { _virbom_manipulator } from "../utils/frfr-virbom-manipulator-utils";


// TER DRAFTEL CODECS LIB

/*

*/


export const draftel_codecs_pack_terkk$demper = {};


// ---------- CODEC SCHEMA METHODS ----------


draftel_codecs_pack_terkk$demper.default_preset_state = () => {
  const preset_state = {
    _draftelschemakey: 'terkk$demper',
    terkknivo: 'CHILDOFMODUL', // ???
    // ID polje ne ide u preset, dobija se samo u EDIT MODE ali i tada mora biti obezbedjeno
    tipdempera: 'standardni',
    unutrasnjasirina: null,
    unutrasnjavisina: null,
    vrstapogona: 'motorni',
    osovina: '110', // NJ 2024: Potrebno je promeniti defaultne vrednosti za osovine na motorni pogon sa 75mm na 110mm.
    kolicina: 1,
  };
  return preset_state;
};


draftel_codecs_pack_terkk$demper.keys_for_direct_cloning = [
  "rev_id",
  "superkey",
  "subkey",
  "parent_subkey",
  ...Object.keys(draftel_codecs_pack_terkk$demper.default_preset_state())
];


// ---------- CODEC ENCODING  - DRAFTEL TO VIRBOM DIRECTION ----------


draftel_codecs_pack_terkk$demper.drafel_to_virtel = (formState) => {
  // pretvara iz formState u virtel format sa ispravnim flagovima
  const sema = virtel_schema_smart_get('terkk$demper');
  console.log(formState);
  let state = {
    ...formState
  };
  if (typeof state.osovina === 'string') {
    state.osovina = Number.parseInt(state.osovina); // pretvaramo u broj
  }
  const p = state;
  const demperNaziv = _derivat_demper_izracunaj_naziv(p);
  state.naziv = demperNaziv;
  state.display_brojkrilaca = _derivat_demper_izracunaj_brojkrilaca(p.unutrasnjavisina);
  //
  const state2 = {
    virtelschemakey: 'terkk$demper',
    ...state,
    flag_paired_with_smartel: true, // ovaj virtel direktno uparen sa smartel.subkey
    ..._get_fixed_fields(sema),
    ..._getParamsFromLib("terkk$demper") // parametri na kraju imaju prioritet
  };
  return state2; // return virtel
};


draftel_codecs_pack_terkk$demper.drafel_to_virbom = (draftel) => {
  // MAIN CONVERT METHOD
  // const sema = virtel_schema_smart_get('terkk$demper');
  const virtel = draftel_codecs_pack_terkk$demper.drafel_to_virtel(draftel);

  let virbom_ref = _virbom_manipulator.init(virbomCounter.generateFreshSubkey);

  // KORAK poluproizvod level 3 virtel
  // graphlevel: 3,
  // const graphlevel = 3;
  const local_graphlevel = 1;
  // _virbom_manipulator.add_on_graphlevel(virbom_ref, virtel_demper, 3);
  _virbom_manipulator.add_as_first_virtel(virbom_ref, virtel);

  // KORAK pripreme derivata za profile dempera
  let pods_input_za_derivate = derAutoCreateVirbom_terkk_demper_prepare_vir_input(draftel); // ??? 
  let _derivati = derAutoCreateVirbom_terkk_demper_children(pods_input_za_derivate);
  console.log('_derivati DEMPER');
  console.log(_derivati);
  // USISAVANJE
  _virbom_manipulator._merge_virbom_into_virbom_on_graphlevel(virbom_ref, _derivati, local_graphlevel + 1, virbomCounter.generateFreshSubkey);

  // ZAVRSENI KORACI ZA JEDAN pp3

  const virbom_seq = _virbom_manipulator.deinit(virbom_ref);
  return virbom_seq; // return virbom
};


// ---------- CODEC DECODING - VIRBOM TO DRAFTEL DIRECTION ----------


draftel_codecs_pack_terkk$demper.virtel_to_draftel = (virtel) => {
  // pretvara iz virtela u formState format
  //
  let state = {
    ...draftel_codecs_pack_terkk$demper.default_preset_state(),
    ...js_utils.clone_obj_but_only_selected_keys(virtel, draftel_codecs_pack_terkk$demper.keys_for_direct_cloning)
  };
  /*
  if (typeof state.osovina === 'number') {
    state.osovina = state.osovina.toString(); // pretvaramo u string
  }
  */
  state.display_brojkrilaca = _derivat_demper_izracunaj_brojkrilaca(state.unutrasnjavisina);
  //
  return state;
};

